import {Text} from "@chakra-ui/react";
import {Avatar} from "./ui/avatar";
import {OwnerPayload} from "platformed-client/types";
import TeamAvatar from "../components/TeamAvatar";

export const OwnerAvatar = ({owner}: {owner: OwnerPayload}) => {
  if (owner.type === "User") {
    return (
      <>
        <Avatar
          src={owner.content.avatar_url ?? undefined}
          name={owner.content.name ?? owner.content.primary_email ?? undefined}
          size="xs"
        />
        <Text>{owner.content.name ?? owner.content.primary_email}</Text>
      </>
    );
  } else {
    return (
      <>
        <TeamAvatar size="xs" />
        <Text>{owner.content.name}</Text>
      </>
    );
  }
};
